<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForWeightAndNoiseMasterForm
        ref="feesForWeightAndNoiseMasterForm"
        v-model="feesForWeightAndNoiseMasterFormModel"
        :originalFormModel="originalFormModel"
        label-width="10em"
        formMode="edit"
        :editDisabledMode="editDisabledMode"
        :routeAirportCodeList="routeAirportCodeList"
        tableType="WEIGHT_AND_NOISE"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForWeightAndNoiseMasterForm from '@/components/organisms/dialog/feeMaster/FeesForWeightAndNoiseMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
// import FeesForWeightAndNoiseAutocompleteLoader from '@/mixins/FeesForWeightAndNoiseAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForWeightAndNoiseMasterForm,
    EditDialogFooter
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForWeightAndNoiseMasterFormModel: {
        charge_year: undefined,
        route_code: undefined,
        jet_type: undefined,
        paid_type: undefined,
        row_number: undefined,
        min_weight: undefined,
        max_weight: undefined,
        weight_update_flag: false,
        weights: [{ data_range_from: undefined, data_range_to: undefined, charge: undefined, flat_charge_flag: undefined }],
        noise_update_flag: false,
        noises: [{ data_range_from: undefined, data_range_to: undefined, charge: undefined, flat_charge_flag: undefined }],
        remote_island_update_flag: false,
        remoteIslands: [{ route_airport_code: undefined, exemption_rate_by_remote_island: undefined }],
        route_discount_update_flag: false,
        // route_and_weights: [{ exemption_type_by_route_and_weight: undefined, route_airport_code: undefined, exemption_rate_by_route_and_weight: undefined }],
        routeDiscounts: [{ route_airport_code: undefined, exemption_rate_by_route: undefined, error_check_flag: 0 }],
        weight_discount_update_flag: false,
        weightDiscounts: [{ min_weight: undefined, max_weight: undefined, exemption_rate_by_weight: undefined }],
        type_update_flag: false,
        // types: [{ exemption_type_by_type: undefined, type_value: undefined, exemption_rate_by_type: undefined }],
        types: [{ type_value: undefined, exemption_rate_by_type: undefined }],
        updated_on: undefined
      },
      routeAirportCodeList: [],
      // oldRouteDiscountsList: []
      originalFormModel: {}
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForWeightAndNoiseMasterFormModel.regist_type === '1' || parseInt(this.feesForWeightAndNoiseMasterFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  // async mounted () {
  //   await this.$axios
  //     .get('/route-airport-code')
  //     .then((res) => {
  //       this.routeAirportCodeList = res.data.list
  //       console.log(this.routeAirportCodeList)
  //       // for (var i = 0; i <= this.routeAirportCodeList.length - 1; i += 1) {
  //       //   // this.tableData[i].selected = false
  //       //   this.$set(this.routeAirportCodeList[i], 'selected', false)
  //       // }
  //     })
  //     .catch((e) => {
  //       console.log(e)
  //     })
  // },
  mounted () {
    // this.getRouteAirportCode()
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      // this.checkRouteAirportCode() // 入れるなら116行目の上に挿入（thenの中）
      this.$refs.feesForWeightAndNoiseMasterForm.validate()
        .then((valid) => {
          if (!this.checkRouteAirportErrorFlag()) {
            return this.$message.error({
              message: '適用路線空港コードが重複しています',
              showClose: true
            })
          }
          return this.$axios.put('/fees-for-weight-and-noise-master', this.feesForWeightAndNoiseMasterFormModel)
        })
        // .then((res) => {
        //   return this.$axios.put('/fees-for-weight-and-noise-master', this.feesForWeightAndNoiseMasterFormModel)
        // })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForWeightAndNoiseMasterFormModel.charge_year)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    async getRouteAirportCode () {
      await this.$axios
        .get('/route-airport-code')
        .then((res) => {
          this.routeAirportCodeList = res.data.list
          console.log(this.routeAirportCodeList)
          // for (var i = 0; i <= this.routeAirportCodeList.length - 1; i += 1) {
          //   // this.tableData[i].selected = false
          //   this.$set(this.routeAirportCodeList[i], 'selected', false)
          // }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    open () {
      this.getRouteAirportCode()
      // this.$loadingMask.on() //ダイアログの裏でloadingmaskがかかってしまう
      const trimItem = ['bill_to_code', 'route_code', 'type_value']
      this.$nextTick(() => {
        this.$refs.feesForWeightAndNoiseMasterForm.clearFields()
        Object.keys(this.feesForWeightAndNoiseMasterFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.feesForWeightAndNoiseMasterFormModel, x, this.currentRow[x])
            this.feesForWeightAndNoiseMasterFormModel.weight_update_flag = false
            this.feesForWeightAndNoiseMasterFormModel.noise_update_flag = false
            this.feesForWeightAndNoiseMasterFormModel.remote_island_update_flag = false
            this.feesForWeightAndNoiseMasterFormModel.route_discount_update_flag = false
            this.feesForWeightAndNoiseMasterFormModel.weight_discount_update_flag = false
            this.feesForWeightAndNoiseMasterFormModel.type_update_flag = false
            // alert('currentRow:' + this.currentRow[x])
          })
        // FeesForWeightAndNoiseMasterPage.vueで呼び出すのでコメントアウト
        // const searchCond = JSON.parse(JSON.stringify(this.feesForWeightAndNoiseMasterFormModel))
        // this.$axios
        //   .get('/search-fees-for-weight-and-noise-detail-master', { params: searchCond })
        //   .then((res) => {
        //     this.feesForWeightAndNoiseMasterFormModel.weights = res.data.list
        //     console.log(this.feesForWeightAndNoiseMasterFormModel.weights)
        //     // for (var i = 0; i <= this.tableData.length - 1; i += 1) {
        //     //   // this.tableData[i].selected = false
        //     //   this.$set(this.tableData[i], 'selected', false)
        //     // }
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })
        //   .finally(() => {
        //     this.$loadingMask.off()
        //   })
        this.originalFormModel = JSON.parse(JSON.stringify(this.feesForWeightAndNoiseMasterFormModel))
        // this.originalFormModel = Object.assign({}, this.feesForWeightAndNoiseMasterFormModel)
      })
      // alert('feesForWeightAndNoiseMasterFormModel:' + this.feesForWeightAndNoiseMasterFormModel)
      // alert('JSON.stringify:' + JSON.stringify(this.feesForWeightAndNoiseMasterFormModel))
      // const parentKeyModel = this.feesForWeightAndNoiseMasterFormModel[Object.keys(this.feesForWeightAndNoiseMasterFormModel)[0]]
      // const parentKeyModel = (({ charge_year, route_code, jet_type, paid_type, row_number }) => ({ charge_year, route_code, jet_type, paid_type, row_number }))(this.feesForWeightAndNoiseMasterFormModel);
      // alert('parentKeyModel:' + parentKeyModel)
    },
    checkRouteAirportErrorFlag () {
      console.log('1')
      var result = true
      const errorFlagCheckList = this.feesForWeightAndNoiseMasterFormModel.routeDiscounts.map(obj => obj.error_check_flag)
      console.log('2')
      if (errorFlagCheckList.includes(1)) {
        console.log('3')
        // this.$fcMessage.showMessage(this.errorCheckFlagMessage)
        // this.$message.error({
        //   message: '適用路線空港コードが重複しています',
        //   showClose: true
        // })
        result = false
      }
      return result
    },
    checkRouteAirportCode () {
      const routeAirportCheckList = this.feesForWeightAndNoiseMasterFormModel.routeDiscounts.map(obj => obj.route_airport_code)
      console.log(routeAirportCheckList)
      if (this.isDuplicated(routeAirportCheckList)) {
        console.log('配列の中に重複があります')
        // this.$fcMessage.showMessage(this.$fcMessage.getMessage('CMN0001E', ''))
      } else {
        console.log('配列の中に重複はありません')
      }
      // for (var i = 0; i <= routeAirportCheckList.length; i += 1) {
      //   if (routeAirportCheckList.lastindexOf(i) !== i) {
      //     // this.$refs.feesForWeightAndNoiseMasterFormModel.routeDiscounts[i].route_airport_code.checkDuplicate()
      //     console.log('配列の中に重複があります')
      //   } else {
      //     console.log('配列の中に重複はありません')
      //   }
      // }
      // var duplicate_list = route_airport_check_list.filter(function (x, i, self) {
      //   return self.indexOf(x) === i && i !== self.lastIndexOf(x);
      // });
    },
    // 重複があればtrue、なければfalseを返す関数
    isDuplicated (elements) {
      // Setを使って、配列の要素を一意にする
      const setElements = new Set(elements)
      return setElements.size !== elements.length
    }
  }
}
</script>

<style lang="scss">
</style>
